import { ImageLoader } from "~/components/ImageLoader";
import { ButtonVariants, getButtonClassName } from "~/components/Button";
import { Asset } from "~/modules/assets/types";
import { TokenHoldersUserEvents } from "~/modules/analytics/events/tokenHolders";
import { useRegistrationModal } from "~/modules/auth/hooks/useRegistrationModal";

// // // //

/**
 * Renders a login CTA for AssetTokenHolders
 */
export function TokenHoldersLoginCTA(props: { asset: Asset }) {
    const { asset } = props;
    const { open: openRegistrationModal } = useRegistrationModal();

    return (
        <div className="relative isolate overflow-hidden px-6 pt-16 sm:px-16 md:pt-24 lg:flex lg:gap-x-20 lg:px-24 lg:pt-0">
            <div className="mx-auto max-w-md text-center lg:mx-0 lg:flex-auto lg:py-32 lg:text-left">
                <h2 className="text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
                    View detailed token
                    <br />
                    holder breakdowns
                </h2>
                <p className="mt-6 text-lg leading-8 text-secondary-foreground">
                    Sign up for a free account to get access to breakdowns of
                    which investor addresses hold an RWA across blockchain
                    networks.
                </p>
                <div className="mt-10 flex items-center justify-center gap-x-6 lg:justify-start">
                    <button
                        onClick={() => {
                            openRegistrationModal({
                                label: TokenHoldersUserEvents.ClickLogincCta,
                                properties: {
                                    asset_id: String(asset.id),
                                    asset_ticker: asset.ticker ?? "",
                                },
                            });
                        }}
                        className={getButtonClassName({
                            size: "md",
                            variant: ButtonVariants.primaryLink,
                            className: "gap-2",
                        })}
                    >
                        Log in to Unlock
                        <span aria-hidden="true">→</span>
                    </button>
                </div>
            </div>
            <div className="relative mt-16 h-80 lg:mt-8">
                <ImageLoader
                    className="absolute left-0 top-0 w-228 max-w-none rounded-lg bg-white/5 ring-1 ring-white/10 shadow-lg border"
                    src="/holders-product-screenshot.png"
                    alt="Holders Product Screenshot"
                />
            </div>
        </div>
    );
}
